var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    ref: "TaskTable",
    staticClass: "elevation-2 myDense",
    attrs: {
      headers: _vm.headersFBM,
      items: _vm.product,
      "item-key": "key",
      search: _vm.filter,
      expand: _vm.expand,
      pagination: _vm.pagination,
      "rows-per-page-items": _vm.rowPerPage
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function(props) {
          return [
            _c(
              "tr",
              {
                on: {
                  click: function($event) {
                    props.expanded = !props.expanded
                  }
                }
              },
              [
                _c("td", { staticClass: "subheading" }, [
                  _vm._v(_vm._s(props.index + 1))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.userName))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.siteName || "warehouse"))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(props.item.quantity))
                ])
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f38ae62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f38ae62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductTable.vue
// module id = null
// module chunks = 